import { render, staticRenderFns } from "./c-page-header.vue?vue&type=template&id=099c79d4&scoped=true&"
import script from "./c-page-header.vue?vue&type=script&lang=js&"
export * from "./c-page-header.vue?vue&type=script&lang=js&"
import style0 from "./c-page-header.vue?vue&type=style&index=0&id=099c79d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c79d4",
  null
  
)

export default component.exports